'use strict';

const CompareToDirective = function () {

  const link = (scope, el, attrs, ngModel) => {

    ngModel.$validators.compareTo = (modelValue) => {

      return modelValue === scope.otherModelValue;
    };

    scope.$watch('otherModelValue', () => {

      ngModel.$validate();
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    require: 'ngModel',
    scope: {
      otherModelValue: '=compareTo'
    },
    link
  };
};

module.exports = CompareToDirective;



// WEBPACK FOOTER //
// ./src/app/login/directives/CompareToDirective.js